<template>
  <div class="max-h-[calc(70vh-120px)]">
    <form @submit.prevent="submitForm" class="space-y-4">
      <div class="grid grid-cols-2 gap-x-20 gap-y-6 px-20">
        <div>
          <label for="brandName" class="block text-sm font-medium text-gray-700"
            >Item Code<span class="text-red-500">*</span></label
          >
          <input
            type="text"
            id="code"
            v-model="form.code"
            placeholder="Type...(e.g. IT0012)"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
          <span class="text-sm text-red-500" v-if="this.errors.code">
            Item code is required
          </span>
        </div>
        <div>
          <label for="itemName" class="block text-sm font-medium text-gray-700"
            >Item Name<span class="text-red-500">*</span></label
          >
          <input
            type="text"
            id="itemName"
            v-model="form.trade_name"
            placeholder="Type...(e.g. Latex Gloves)"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
          <span class="text-sm text-red-500" v-if="this.errors.trade_name">
            Item name is required
          </span>
        </div>
        <div>
          <label
            for="storageConditions"
            class="block text-sm font-medium text-gray-700"
            >Storage Conditions<span class="text-red-500">*</span></label
          >
          <select
            id="storageConditions"
            v-model="form.storage_conditions"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option
              v-for="storage of storageConditions"
              :key="storage.id"
              :value="storage.label"
            >
              {{ storage.label }}
            </option>
          </select>
          <span
            class="text-sm text-red-500"
            v-if="this.errors.storage_conditions"
          >
            Storage condition is required
          </span>
        </div>
        <div>
          <label
            for="manufacturer"
            class="block text-sm font-medium text-gray-700"
            >Manufacturer</label
          >
          <input
            type="text"
            id="manufacturer"
            v-model="form.manufacturer"
            placeholder="Type... (eg. Plasti Surge Industries Pvt Ltd)"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
        </div>
        <!-- <div>
                    <label for="location" class="block text-sm font-medium text-gray-700">Location in the
                        Hospital<span class="text-red-500">*</span></label>
                    <select id="location" v-model="form.location"
                        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50">
                        <option value="Triage/Consultation/Pharmacy">Triage/Consultation/Pharmacy</option>
                    </select>
                </div> -->
      </div>
      <div class="flex justify-end mt-6 gap-y-6 px-20">
        <button
          type="submit"
          class="px-4 py-2 bg-custom-yellow text-white rounded-md hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-custom-yellow focus:ring-opacity-50"
        >
          <span v-if="!showLoader"> Submit </span>
          <span v-else>
            <svg
              class="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
                fill="none"
              />
            </svg>
          </span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import apiClient from "@/services/api";

export default {
  name: "NonPharmaceuticalFormTab",
  data() {
    return {
      form: {
        code: "",
        item_type: 2,
        trade_name: "",
        storage_conditions: "",
        manufacturer: "",
      },
      errors: {},
      storageConditions: [
        { id: 1, label: "Normal" },
        { id: 2, label: "Refrigarated" },
      ],
      showLoader: false,
    };
  },
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }
      try {
        this.showLoader = true;
        const response = await apiClient.createInventoryItem(this.form);
        if (response.success) {
          this.showLoader = false;
          this.$toast.success("Inventory Item created successfully");
          this.$router.push("/inventory");
        } else {
          this.showLoader = false;
          this.$toast.error(response.message);
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to create inventory item");
        console.log(error);
      }
    },
    validateForm() {
      this.errors = {};
      let count = 0;

      const fields = ["code", "trade_name", "storage_conditions"];

      fields.forEach((field) => {
        if (!this.form[field]) {
          count = count + 1;
          this.errors[field] = true;
        }
      });

      if (count > 0) {
        return false;
      }

      return true;
    },
  },
};
</script>
